import React from 'react';
import useEmailDomainFunctions from 'components/Dashboard/hooks/useEmailDomainFunctions';
import { useEffect } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Loading from 'components/Login/Loading';
import { useNavigate } from 'react-router';

function EmailVerificationSucccess() {
  const { syncEmailDomain } = useEmailDomainFunctions();
  const navigate = useNavigate();

  let initialCall = async (source) => {
    let res = await syncEmailDomain({ isAdminPage: false, source });
    if (res || res === false) {
      navigate('/people/emails');
    }
  };

  useEffect(() => {
    const source = new AbortController();

    try {
      initialCall(source);
    } catch (e) {}

    return () => {
      source.abort('Email sync canceled by the user.');
    };
  }, []);
  return <></>;
}

export default withAuthenticationRequired(EmailVerificationSucccess, {
  onRedirecting: () => <Loading />,
});
